import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input } from 'reactstrap';
import { getIn } from 'formik';

const FormTextarea = ({
  className = '',
  inputClassName = '',
  label,
  name,
  value,
  placeholder,
  disabled,
  isShowLabel = true,
  touched,
  errors,
  rows = 4,
  onChange,
  onFocus,
  onBlur
}) => {
  // const isError = touched && errors && touched[name] && errors[name];
  const fieldTouched = getIn(touched, name);
  const fieldError = getIn(errors, name);
  const isError = fieldTouched && fieldError;

  return (
    <FormGroup className={className}>
      {isShowLabel && <Label htmlFor={name}>{label}</Label>}
      <Input
        type="textarea"
        name={name}
        value={value}
        placeholder={placeholder}
        rows={rows}
        className={`form-control ${isError ? 'is-invalid' : ''} ${inputClassName}`}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        disabled={disabled}
      />
      {isError && <span className="invalid-feedback">{fieldError}</span>}
    </FormGroup>
  );
};

// PropTypes validation
FormTextarea.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isShowLabel: PropTypes.bool,
  touched: PropTypes.object,
  errors: PropTypes.object,
  rows: PropTypes.number,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};

export default FormTextarea;
